const initialState = {
  requests: [],
  lastDocument: null,
  hasMore: true,
  helpRequests: [],
  lastDocumentRequest: "",
  hasMoreRequest: true,
};

const managerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_MANAGER_HELP_REQUESTS":
      console.log(action.payload);
      return {
        ...state,
        helpRequests: action.payload.requests,
        lastDocumentRequest: action.payload.lastDocument,
        hasMoreRequest: action.payload.hasMore,
      };
    case "GET_MANAGER_HELP_REQUESTS_MORE":
      console.log(action.payload);
      return {
        ...state,
        helpRequests: [...state.helpRequests, ...action.payload.requests],
        lastDocumentRequest: action.payload.lastDocument,
        hasMoreRequest: action.payload.hasMore,
      };
    case "ADD_REQUEST":
      return {
        ...state,
        requests: [action.payload, ...state.requests],
      };
    case "FETCH_MANAGER_REQUESTS":
      return {
        ...state,
        requests: action.payload.data,
        lastDocument: action.payload.lastVisible,
        hasMore: action.payload.hasMore,
      };
    case "FETCH_MANAGER_REQUESTS_LOAD_MORE":
      return {
        ...state,
        requests: [...state.requests, ...action.payload.data],
        lastDocument: action.payload.lastVisible,
        hasMore: action.payload.hasMore,
      };
    case "DELETE_REQUEST":
      return {
        ...state,
        requests: state.requests.filter(
          (request) => request.id !== action.payload
        ),
      };
    case "EDIT_REQUEST":
      return {
        ...state,
        requests: state.requests.map((request) =>
          request.id === action.payload.id
            ? { ...request, ...action.payload }
            : request
        ),
      };

    default:
      return {
        ...state,
      };
  }
};

export default managerReducer;
